module.exports = __webpack_public_path__ + "static/media/stereo.2761c524.png";